/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Videos_TitleInputs */

const cs_projects_videos_title = /** @type {(inputs: Projects_Videos_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videa projektu`)
};

const en_projects_videos_title = /** @type {(inputs: Projects_Videos_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project videos`)
};

/**
* | output |
* | --- |
* | "Project videos" |
*
* @param {Projects_Videos_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_videos_title = /** @type {((inputs?: Projects_Videos_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Videos_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_videos_title(inputs)
	return cs_projects_videos_title(inputs)
});